import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a cross-origin "Script error."
    const errorMessage = error?.message || error?.toString() || '';
    const isScriptError = (
      errorMessage === 'Script error.' ||
      errorMessage.includes('Script error.') ||
      (!error?.stack && !error?.source && !errorMessage) ||
      (errorMessage === 'ERROR' && !error?.stack)
    );
    
    // Suppress cross-origin script errors - don't show error UI
    if (isScriptError) {
      // Immediately hide any error overlays that might appear
      setTimeout(() => {
        try {
          const overlays = document.querySelectorAll('[class*="error"], [id*="error"], [class*="overlay"]');
          overlays.forEach(el => {
            const text = (el.innerText || el.textContent || '').toString();
            if (text.includes('Script error') || (text.includes('ERROR') && text.length < 100)) {
              el.style.display = 'none';
              el.style.visibility = 'hidden';
            }
          });
        } catch (_) {}
      }, 0);
      return { hasError: false, error: null }; // Suppress the error
    }
    
    // For real errors, allow them to be displayed
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Check if this is a cross-origin script error
    const errorMessage = error?.message || error?.toString() || '';
    const isScriptError = (
      errorMessage === 'Script error.' ||
      errorMessage.includes('Script error.') ||
      (!error?.stack && !error?.source && !errorMessage) ||
      (errorMessage === 'ERROR' && !error?.stack)
    );
    
    // Suppress cross-origin script errors - don't log them
    if (isScriptError) {
      // Force hide any error overlays
      setTimeout(() => {
        try {
          const overlays = document.querySelectorAll('[class*="error"], [id*="error"], [class*="overlay"], [id*="overlay"]');
          overlays.forEach(el => {
            const text = (el.innerText || el.textContent || '').toString();
            if (text.includes('Script error') || (text.includes('ERROR') && text.length < 150)) {
              el.style.display = 'none';
              el.style.visibility = 'hidden';
              el.style.pointerEvents = 'none';
              el.style.opacity = '0';
            }
          });
        } catch (_) {}
      }, 0);
      return; // Silently ignore
    }
    
    // Log real errors only
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    // If we have a real error (not suppressed), show error UI
    if (this.state.hasError && this.state.error) {
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
          </details>
        </div>
      );
    }

    // Otherwise render children normally
    return this.props.children;
  }
}

export default ErrorBoundary;

